import React, {useEffect, useState} from "react";
import {useDeleteProject, useExportProjectExcel, useReadProjectList,} from "../hooks";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import {SubmitHandler, useForm} from "react-hook-form";
import EmptyTableRow from "../../../common/EmptyTableRow";
import useSelectCheckbox from "../../../../hooks/useSelectCheckbox";
import {PaginationMain} from "../../../../components/common/pagination/PaginationMain";
import {useSearchParams} from "react-router-dom";
import {useModal} from "../../../../hooks";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

type Props = {};

export const ProjectList = (props: Props) => {
    const {handleModal} = useModal();
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const defaultSearchValue = {
        fromDate: "",
        limit: 10,
        pageNo: 1,
        state: "0",
        toDate: "",
    };
    const [searchOption, setSearchOption] =
        useState<AccountSearchInterface>(defaultSearchValue);
    const {selectList, handleSelectCheckbox, isSelected, selectAll, clear} =
        useSelectCheckbox();

    const {data: projectData} = useReadProjectList({
        searchData: searchOption,
    });

    const {mutate: exportExcelMutate} = useExportProjectExcel();
    const {mutate: deleteMutate} = useDeleteProject({clear});

    const {goToNavigation} = useGoToNavigation();

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<AccountSearchInterface> = (submitData) => {
        clear();
        setSearchOption(submitData);
    };

    const data = projectData?.list;
    const totalCount = projectData?.totalCount;

    useEffect(() => {
        setSearchOption({...searchOption, pageNo: page});
    }, [page]);

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">프로젝트 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <form className="row" onSubmit={handleSubmit(onSubmit)}>
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">
                                상태
                            </label>
                            <select className="form-select w-150px" {...register("state")}>
                                <option value="0">전체</option>
                                <option value="1">요청</option>
                                <option value="2">진행</option>
                                <option value="3">성공</option>
                                <option value="4">실패</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label className="form-label frm_label">프로젝트 기간</label>
                            <div className="frm_field">
                                <div className="frm_field input_date">
                                    <input
                                        type="date"
                                        className="form-control"
                                        max="9999-12-31"
                                        {...register("fromDate")}
                                    />
                                    <span className="txt_range">~</span>
                                    <input
                                        type="date"
                                        className="form-control"
                                        max="9999-12-31"
                                        {...register("toDate")}
                                    />
                                    <button className="btn btn-info btn_search">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/icon_search.png"
                                            }
                                            alt=""
                                        />
                                        조회
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">
                        프로젝트 목록(<span>{totalCount}</span>건)
                    </h6>
                    <div className="table_toolbar">
                        <button
                            className="btn btn-dark w-150px px-0"
                            onClick={() => {
                                exportExcelMutate(searchOption);
                            }}
                        >
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"}
                                alt=""
                            />
                            엑셀 내보내기
                        </button>
                        <AuthorityChecker authorityNames={['projectWriteYn']}>
                            <button
                                className="btn btn-primary w-120px px-0 ms-40px"
                                onClick={() => {
                                    goToNavigation("customer/project/create", {}, false);
                                }}
                            >
                                프로젝트 생성
                            </button>
                            <button
                                className="btn btn-outline-dark w-100px px-0"
                                onClick={() => {
                                    if (selectList.length === 0) {
                                        handleModal({
                                            isOpen: true,
                                            contents: "삭제할 항목을 선택해주세요.",
                                            type: "alert"
                                        })

                                        return;
                                    }

                                    handleModal({
                                        isOpen: true,
                                        contents: "삭제하시겠습니까?",
                                        type: "confirm",
                                        callback: () => {
                                            const deleteList = data?.filter((item) => {
                                                if (selectList.includes(item?.projectId)) {
                                                    return item;
                                                }
                                            });
                                            if (deleteList && deleteList?.length > 0) {
                                                deleteMutate(
                                                    deleteList.map((item) => {
                                                        return {id: item?.projectId};
                                                    })
                                                );
                                            }
                                        }
                                    })
                                }}
                            >
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"}
                                    alt=""
                                />
                                선택삭제
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                        <tr>
                            <th rowSpan={2} style={{width: "5%"}}>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        onClick={() => {
                                            if (data) {
                                                selectAll(
                                                    data.map((item) => {
                                                        return {...item, _id: item.projectId};
                                                    })
                                                );
                                            }
                                        }}
                                        checked={
                                            data && data?.length > 0
                                                ? data?.length <= selectList.length
                                                : false
                                        }
                                    />
                                </div>
                            </th>
                            <th rowSpan={2} style={{width: "10%"}}>
                                시작일

                            </th>
                            <th rowSpan={2} style={{width: "10%"}}>
                                종료일

                            </th>
                            <th rowSpan={2} style={{width: "20%"}}>
                                프로젝트명

                            </th>
                            <th rowSpan={2} style={{width: "12%"}}>
                                PM

                            </th>
                            <th colSpan={2} style={{width: "28%"}}>
                                고객
                            </th>
                            <th rowSpan={2}>
                                상태

                            </th>
                        </tr>
                        <tr>
                            <th style={{width: "14.375%"}}>
                                거래처

                            </th>
                            <th style={{width: "14.375%"}}>
                                연락처

                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {data?.length === 0 ? (
                            <EmptyTableRow/>
                        ) : (
                            data?.map((item) => (
                                <tr
                                    className={isSelected({_id: item?.projectId}) ? "clickable lightblue" : "clickable"}
                                    onClick={() => {
                                        goToNavigation(
                                            "customer/project/detail/" + item?.projectId,
                                            {},
                                            false
                                        );
                                    }}
                                >
                                    <td
                                        onClick={(e: React.MouseEvent<any>) => {
                                            e.stopPropagation();
                                        }}
                                    >
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                    e.stopPropagation();
                                                    handleSelectCheckbox({
                                                        _id: item?.projectId,
                                                    });
                                                }}
                                                checked={isSelected({_id: item?.projectId})}
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center">{item?.startDt}</td>
                                    <td className="text-center">{item?.endDt}</td>
                                    <td>{item?.projectName}</td>
                                    <td className="text-center">{item?.pmName}</td>
                                    <td className="text-center">{item?.customerAccountName}</td>
                                    <td className="text-center">{}</td>
                                    <td className="text-center">{item?.stateName}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>

                <PaginationMain totalCount={totalCount ?? 0}/>
            </div>
        </>
    );
};
